import React, { useState } from 'react';
import styled from 'styled-components';
import { useAiAssistant } from '../../AiAssistantContext';
import ProjectsPanel from './ProjectsPanel';
import SessionsPanel from './SessionsPanel';
import FilesPanel from './FilesPanel';

const Sidebar: React.FC = () => {
  const { state } = useAiAssistant();
  const hasProject = !!state.selectedProjectId;
  const [projectsCollapsed, setProjectsCollapsed] = useState(false);
  const [sessionsCollapsed, setSessionsCollapsed] = useState(false);
  const [filesCollapsed, setFilesCollapsed] = useState(false);

  return (
    <Container>
      <Section $collapsed={projectsCollapsed}>
        <ProjectsPanel collapsed={projectsCollapsed} onToggle={() => setProjectsCollapsed((v) => !v)} />
      </Section>
      {hasProject && (
        <>
          <Divider />
          <Section $collapsed={sessionsCollapsed}>
            <SessionsPanel collapsed={sessionsCollapsed} onToggle={() => setSessionsCollapsed((v) => !v)} />
          </Section>
          <Divider />
          <Section $collapsed={filesCollapsed}>
            <FilesPanel collapsed={filesCollapsed} onToggle={() => setFilesCollapsed((v) => !v)} />
          </Section>
        </>
      )}
    </Container>
  );
};

export default Sidebar;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

const Section = styled.div<{ $collapsed: boolean }>`
  flex: ${(p) => (p.$collapsed ? '0 0 auto' : '1')};
  min-height: 0;
  overflow-y: ${(p) => (p.$collapsed ? 'hidden' : 'auto')};
  padding: 8px;
`;

const Divider = styled.div`
  height: 1px;
  background: #ddd;
  margin: 0 8px;
  flex-shrink: 0;
`;
